// npm imports
import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { debounce } from "lodash";

// Components Imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "react-responsive-modal";
import { Toastr, Input } from "../../../../revvComponents";
import SelectTemplateList from "./SelectTemplateList";
import AssetUploadTemplate from "./AssetUploadTemplate";
import DocumentCtaSelection from "./DocumentCtaSelection";
import { UpgradePopUpV2 } from "../../../../commonComponents";

// Actions Imports
import { DocumentTemplateActions } from "../../../../actions";
import {
  createDocumentAndContent,
  saveDocument,
} from "../../../../actions/DocumentActions";

// Services Imports
import { deleteDocumentComponentService } from "../../../../actions/DocumentActions/services";

// Internal Imports
import { GlobalUtils, AmplitudeUtils } from "../../../../utils";
import CreateDocumentNotes from "../../../RevvEditor/createDocumentNotes";
import { PATHS, EVENTS } from "../../../../constants";
import { customGAEvent } from "../../../../gtm/gtmutils";
import {
  GTM_CUSTOM_EVENTS,
  GTM_EVENT_PARAMS,
} from "../../../../gtm/gtmcustomevents";
import LZLoader from "../../../../commonComponents/LZLoader";

// Destructuring
const { getTemplateInitData, searchTemplates } = DocumentTemplateActions;
const { handleApiErrMsg, writeDataToLocalStorage, checkFreePlan } = GlobalUtils;
const { amplitudeLogEvent } = AmplitudeUtils;
const POPUP_SIZE_CLASSNAME_MAP = {
  MEDIUM: "medium-size-popup",
};
class AssetCreateDocumentPopup extends Component {
  //* Make the Search API on 1 sec timeInterval using lodash debunce
  delaySearch = debounce(searchTxt => {
    this.props
      .searchTemplates(searchTxt.trim())
      .then(() => console.debug("Template search success"))
      .catch(err => console.error(err))
      .finally(() => this.setState({ searchingLoader: false }));
  }, 1000);

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      documentIsLoading: false,
      showTemplateSelection: true,
      docURI: null,
      turnAroundDate: moment().add(7, "days").format(),
      errMsg: "",
      loadMoreTemplates: false,
      screen: 1,
      docCtaType: {},
      templateSearchQuery: "",
      searchingLoader: false,
      // showUpgradePopup: false,
    };
    this.popupRef = React.createRef();
  }

  componentDidMount() {
    this.toggleLoading(true);
    this.props
      .getTemplateInitData()
      .then(response => {
        if (response && response.length === 0) {
          this.setState({ showTemplateSelection: false });
        }
        this.toggleLoading(false);
      })
      .catch(() => {
        this.toggleLoading(false);
      });
  }

  componentDidUpdate() {
    // pagination for templates in popup
    const modalScrollElement = document.querySelectorAll(
      ".styles_overlay__CLSq- .assetcreatedoc-block.templates .select-template-list-wrapper",
    );
    if (modalScrollElement && modalScrollElement.length) {
      modalScrollElement[0].removeEventListener(
        "scroll",
        this._loadMoreTemplates,
      );
      modalScrollElement[0].addEventListener("scroll", this._loadMoreTemplates);
    }
  }

  componentWillUnmount() {
    const modalScrollElement = document.querySelectorAll(
      ".styles_overlay__CLSq- .assetcreatedoc-block.templates .select-template-list-wrapper",
    );
    if (modalScrollElement && modalScrollElement.length) {
      modalScrollElement[0].removeEventListener(
        "scroll",
        this._loadMoreTemplates,
      );
    }
  }

  _loadMoreTemplates = () => {
    const modalScrollElement = document.querySelectorAll(
      ".styles_overlay__CLSq- .assetcreatedoc-block.templates .select-template-list-wrapper",
    );
    if (modalScrollElement && modalScrollElement.length) {
      if (
        modalScrollElement[0].scrollTop + modalScrollElement[0].clientHeight >=
        modalScrollElement[0].scrollHeight
      ) {
        const { hasMore, pageNum } = this.props;
        const { loadMoreTemplates, templateSearchQuery } = this.state;
        if (hasMore && !loadMoreTemplates) {
          this.setState({ loadMoreTemplates: true });

          if (templateSearchQuery) {
            this.setState({ searchingLoader: true });
            this.props
              .searchTemplates(templateSearchQuery, pageNum + 1)
              .then(() => {
                this.setState({
                  loadMoreTemplates: false,
                  searchingLoader: false,
                });
              })
              .catch(() => {
                this.setState({
                  loadMoreTemplates: false,
                  searchingLoader: false,
                });
              });
          } else {
            this.props
              .getTemplateInitData(pageNum + 1, true)
              .then(() => {
                this.setState({ loadMoreTemplates: false });
              })
              .catch(() => {
                this.setState({ loadMoreTemplates: false });
              });
          }
        }
      }
    }
  };

  toggleLoading = isLoading => {
    this.setState({ loading: isLoading });
  };

  setDocUri = uri => {
    this.setState({ docURI: uri });
  };

  setErrMsg = msg => {
    this.setState({ errMsg: msg });
  };

  setDoc = docDetails => {
    this.toggleLoading(true);
    // const { name: opportunityName } = this.props.opportunity;
    const opportunityName = "NewAssetDoc";
    const { fileDetails, error } = docDetails;
    if (error) {
      this.setState({ errMsg: error, loading: false });
    } else {
      // No oppurtunity: setting default change later
      saveDocument(fileDetails, opportunityName).then(uri => {
        if (typeof uri === "string") {
          this.setState({ docURI: uri, errMsg: "" });
          this.createDoc();
        } else {
          this.setState({
            docURI: undefined,
            errMsg: "Invalid content in the uploaded docx file",
          });
        }
      });
    }
  };

  // post doc create actions : handle routing
  _postDocCreationAction = (docNo, revisionNo) => {
    this.toggleLoading(false);
    // this.setState({ showBtnLoader: false });
    writeDataToLocalStorage("documentPageSource", this.props.source);
    this.props.history.push(`${PATHS.DOCUMENTS_PATH}/${docNo}`);
    // window.open(`${PATHS.DOCUMENTS_PATH}/${docNo}`, "_blank");
    // this.props.togglePopup();
    console.debug("for amplitude", revisionNo);
  };

  _saveDoc = document => {
    // this.toggleLoading(true);
    createDocumentAndContent(document)
      .then(details => {
        const {
          id,
          components: docComponents,
          doc_no: docNo,
          template_id: templateID,
          document_status: documentStatus,
          document_tag: documentTag,
        } = details.Document;
        const params = {};
        params[GTM_EVENT_PARAMS.FROM_TEMPLATE] = document.template_title;
        customGAEvent(GTM_CUSTOM_EVENTS.DOCUMENT_CREATED, params);
        amplitudeLogEvent(EVENTS.EVENT_NAMES.DOCUMENT_CREATED, {
          initiatedFrom: this.props.source,
          status: documentStatus && documentStatus.name,
          tag: documentTag && documentTag.name,
          DocumentID: id,
          templateID,
        });
        const components = docComponents || [];
        if (!templateID) {
          const commentSection =
            components &&
            components.find(
              section => section.content.section_type === "Comments",
            );
          if (commentSection) {
            const notes = new CreateDocumentNotes({
              id,
              components,
              mode: "DOCUMENT",
            });
            notes.create();
            deleteDocumentComponentService(docNo, commentSection);
          }
          this._postDocCreationAction(docNo, details.revision_no);
        } else {
          this._postDocCreationAction(docNo, details.revision_no);
        }
      })
      .catch(error => {
        console.error(`CreateQuotePopup => _createDocument => ${error}`);
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
        this.setState({ documentIsLoading: false });
      });
  };

  createDoc = template => {
    this.setState({ documentIsLoading: true });
    const defStatus = this.props.assetStatusList[0];
    const { turnAroundDate, docURI, docCtaType } = this.state;
    const { extQuoteId } = this.props;
    const doc = {
      deadline_date: turnAroundDate,
      doc_no: "",
      meta_values: {},
      meta_data: template
        ? {
            ...template.meta_data,
            title_updated: false,
            user_updated_title: false,
            should_update_title: false,
          }
        : {},
      template_id: template ? template.id : null,
      title: "",
      uri: docURI,
      created_from: template ? "template" : "blank/upload",
      folder_id: this.props.currentFolderID || null,
      document_status: defStatus || null,
      document_tag: null,
      quote_ids: extQuoteId ? [extQuoteId] : [],
      document_intent: (docCtaType && docCtaType.eventName) || null,
      template_title: template ? template.title : null,
    };
    this._saveDoc(doc);
  };

  _toggleScreen = (value, docCtaType) => {
    const isFreeplan = checkFreePlan(this.props.billingInfo.plan_type);
    if (docCtaType.upgradeAvilable && isFreeplan) {
      docCtaType.popupScreenType = 4;
      this.setState({ screen: 4, docCtaType });
    } else {
      this.setState({ screen: value, docCtaType });
    }
  };

  _onTemplateSearchChange = event => {
    this.setState({ templateSearchQuery: event.target.value }, () => {
      if (
        this.state.templateSearchQuery.length > 3 ||
        this.state.templateSearchQuery === ""
      ) {
        this.setState({ searchingLoader: true }, () =>
          this.delaySearch(this.state.templateSearchQuery),
        );
      }
    });
  };

  _getPopupScreen = () => {
    const {
      loading,
      showTemplateSelection,
      docCtaType: { popupScreenType },
    } = this.state;
    switch (popupScreenType) {
      case 2:
        return showTemplateSelection ? (
          <div className="assetcreatedoc-block templates">
            <div className="assetcreatedoc-popup-heading">
              <span className="assetcreatedoc-popup-search-wrapper">
                <FontAwesomeIcon
                  icon={["fas", "search"]}
                  className="assetcreatedoc-search-ico"
                />
                <Input
                  className="assetcreatedoc-popup-search"
                  data-test="assetcreatedoc-popup-search"
                  value={this.state.templateSearchQuery}
                  placeholder="Search for templates"
                  onChange={this._onTemplateSearchChange}
                />
                {this.state.searchingLoader && (
                  <FontAwesomeIcon
                    icon={["fas", "spinner"]}
                    className="fa-spin assetcreatedoc-loader-ico"
                  />
                )}
              </span>
            </div>
            <SelectTemplateList
              templates={this.props.documentTemplates}
              loading={loading}
              createDoc={this.createDoc}
            />
          </div>
        ) : null;
      case 3: {
        return (
          <div className="assetcreatedoc-block upload">
            {this.state.errMsg && (
              <div className="error-message-wrapper">
                <span className="error-message-icon">
                  <FontAwesomeIcon icon={["far", "times-circle"]} />
                </span>
                {this.state.errMsg}
              </div>
            )}
            <div className="assetcreatedoc-popup-body">
              <AssetUploadTemplate
                templates={this.props.documentTemplates}
                loading={loading}
                createDoc={this.createDoc}
                setErrMsg={this.setErrMsg}
                setDocUri={this.setDocUri}
                setDoc={this.setDoc}
              />
            </div>
          </div>
        );
      }
      default:
        return null;
    }
  };

  _decideScreenLayout = () => {
    const isFreeplan = checkFreePlan(this.props.billingInfo.plan_type);
    switch (this.state.screen) {
      case 1:
        return (
          <DocumentCtaSelection
            toggleScreen={this._toggleScreen}
            checkFreePlan={isFreeplan}
          />
        );
      case 2:
        return (
          <div className="assetcreatedoc-popup-container">
            <section className="assetcreatedocpopup-header-wrapper">
              <div
                className="assetcreatedoc-popup-back-btn"
                onClick={() => this._toggleScreen(1, {})}
                onKeyPress={() => {}}
                tabIndex="0"
                role="button">
                <FontAwesomeIcon icon={["far", "arrow-left"]} />
              </div>
              <div className="assetcreatedocpopup-title-wrapper">
                <div className="documentctaselection-title">
                  {this.state.docCtaType.popupScreenTitle}
                </div>
                {this.state.docCtaType.popupScreenSubTitle && (
                  <div className="documentctaselection-sub-title">
                    {this.state.docCtaType.popupScreenSubTitle}
                  </div>
                )}
              </div>
            </section>

            <div className="assetcreatedoc-wrapper">
              {this._getPopupScreen()}
            </div>
          </div>
        );
      case 4:
        return (
          <UpgradePopUpV2 type="generic" onClose={this.props.togglePopup} />
        );
      default:
        return <DocumentCtaSelection />;
    }
  };

  render() {
    return (
      <Modal
        open={this.props.isOpen}
        onClose={this.props.togglePopup}
        center="true"
        classNames={{
          modal: `assetcreatedoc-popup ${
            this.state.docCtaType
              ? POPUP_SIZE_CLASSNAME_MAP[this.state.docCtaType.popupScreenSize]
              : ""
          }`,
        }}
        closeOnOverlayClick={false}>
        {/* {this.state.showUpgradePopup && <PlanUpgrade showOnlyOnFreePlan />} */}
        {this.state.documentIsLoading && (
          <LZLoader className="loader-bg-color" label="Creating Document..." />
        )}
        {this._decideScreenLayout()}
      </Modal>
    );
  }
}

const mapStateToProps = ({
  TemplateStore: {
    documentTemplates,
    documentTemplatesInfo: { pageNum, hasMore },
  },
  AssetStore: { currentFolderID, assetStatusList, assetTagsList },
  CommonStore: { billingInfo },
}) => ({
  documentTemplates,
  currentFolderID,
  assetStatusList,
  assetTagsList,
  pageNum,
  hasMore,
  billingInfo,
});

const mapDispatchToProps = {
  getTemplateInitData,
  searchTemplates,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(AssetCreateDocumentPopup));
